<template>
  <div>
    <el-row :gutter="32">
      <el-col :md="12">
        <el-form-item
          for="first-name"
          label="Vorname"
          prop="firstName"
        >
          <el-input
            id="first-name"
            v-model="form.firstName"
          />
        </el-form-item>
      </el-col>

      <el-col :md="12">
        <el-form-item
          for="last-name"
          label="Nachname"
          prop="lastName"
        >
          <el-input
            id="last-name"
            v-model="form.lastName"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item
      for="phone"
      label="Telefon"
      prop="phone"
    >
      <el-input
        id="phone"
        v-model="form.phone"
        type="phone"
        maxlength="24"
      />
    </el-form-item>

    <el-form-item
      for="phone-mobile"
      label="Telefon (mobil)"
      prop="phoneMobile"
    >
      <el-input
        id="phone-mobile"
        v-model="form.phoneMobile"
        type="phone"
        maxlength="24"
      />
    </el-form-item>

    <el-form-item
      for="address"
      label="Straße und Hausnummer"
      prop="address"
    >
      <el-input
        id="address"
        v-model="form.address"
      />
    </el-form-item>

    <el-row :gutter="32">
      <el-col
        :sm="8"
        :md="6"
      >
        <el-form-item
          for="postal-code"
          label="Postleitzahl"
          prop="postalCode"
        >
          <el-input
            id="postal-code"
            v-model="form.postalCode"
            minlength="5"
            maxlength="5"
          />
        </el-form-item>
      </el-col>

      <el-col
        :sm="16"
        :md="18"
      >
        <el-form-item
          for="city"
          label="Ort"
          prop="city"
        >
          <el-input
            id="city"
            v-model="form.city"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item
      label="Foto (max. 1 MB)"
      prop="image"
    >
      <el-upload
        accept="image/*"
        action=""
        :auto-upload="false"
        :drag="true"
        :on-change="handleImageChange"
        :show-file-list="false"
      >
        <img
          v-if="image"
          :src="image"
        >
        <span :class="image ? 'el-icon-edit' : 'el-icon-picture'" />
        <p v-if="!image">
          Ziehen Sie ein Foto in diesen Bereich oder klicken Sie, um ein Foto auszuwählen.
        </p>
      </el-upload>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'CAccountFormCoachPersonal',

  props: {
    temp: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      required: true
    }
  },

  inject: ['elForm'],

  data () {
    return {
      imagePreview: null
    }
  },

  computed: {
    image () {
      return this.imagePreview || this.temp.image
    }
  },

  methods: {
    handleImageChange (file) {
      if (file.raw.type.startsWith('image/')) {
        this.form.image = file.raw
        this.imagePreview = URL.createObjectURL(file.raw)
      }

      this.elForm.validateField('image')
    }
  }
}
</script>
